<div class="card">
  <app-header
    [titulo]="'Executor de Processo: ' + (processo?.nome || '')"
    descricao="Execute o processo e acompanhe o resultado em tempo real.">
  </app-header>

  <p-toolbar styleClass="mb-4">
    <ng-template pTemplate="left">
      <p-button
        label="Voltar"
        icon="pi pi-arrow-left"
        severity="secondary"
        (onClick)="voltar()"
        styleClass="mr-2">
      </p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <p-button
        label="Executar Agora"
        icon="pi pi-play"
        severity="success"
        (onClick)="executar()"
        [loading]="executando">
      </p-button>
    </ng-template>
  </p-toolbar>

  <!-- Progresso -->
  <div *ngIf="executando">
    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
    <div class="text-center p-3">
      <p>Executando processo... Por favor, aguarde.</p>
    </div>
  </div>

  <!-- Resultado -->
  <div *ngIf="resultado" class="mt-4">
    <p-panel header="Resultado da Execução">
      <div class="grid text-center">
        <div class="col">
          <div class="font-medium text-xl">{{ resultado.registrosImportados }}</div>
          <span class="text-500">Importados</span>
        </div>
        <div class="col">
          <div class="font-medium text-xl">{{ resultado.registrosProcessados }}</div>
          <span class="text-500">Processados</span>
        </div>
        <div class="col">
          <div class="font-medium text-xl">{{ resultado.registrosExportados }}</div>
          <span class="text-500">Exportados</span>
        </div>
        <div class="col">
          <div class="font-medium text-xl">{{ resultado.tempoExecucao }} ms</div>
          <span class="text-500">Tempo Total</span>
        </div>
        <div class="col">
          <p-tag [severity]="resultado.sucesso ? 'success' : 'danger'" [value]="resultado.sucesso ? 'Sucesso' : 'Falha'"></p-tag>
          <span class="text-500 d-block">Status Final</span>
        </div>
      </div>
    </p-panel>
  </div>

  <!-- Logs -->
  <div class="mt-4">
    <p-panel header="Log de Execução" [toggleable]="true">
      <p-messages [(value)]="logs" [enableService]="false" [closable]="false"></p-messages>
      <div *ngIf="logs.length === 0 && !executando" class="text-center p-4 text-gray-500">
        <i class="pi pi-align-left text-2xl mb-2"></i>
        <p>Clique em "Executar Agora" para iniciar o processo e visualizar os logs.</p>
      </div>
    </p-panel>
  </div>

</div>
